

























































































































































































































import { Component, Vue, Ref, Watch } from 'vue-property-decorator'
import Chart from '@/components/Chart/index.vue'
import {
  growthRecordExport,
  classroomList,
  growthInfo,
  growthStatic
} from '@/api/teachingProtection/teachManage'

@Component({
  name: 'Teach',
  components: {
    Chart
  }
})
export default class extends Vue {
  private staticTime: (string | number)[] = [Date.now(), Date.now()]; // 统计时间
  private recordTime: (string | number)[] = [Date.now(), Date.now()]; // 记录时间
  private staticForm: any = {
    fromTime: Date.now(),
    toTime: Date.now(),
    classroomIds: []
  };
  private selfHabit: any = this.$enums.selfHabit; // 自助与习惯
  private emotional: any = this.$enums.emotional; // 情感与社会

  private classList: any = []; // 班级
  private infoVisible: boolean = false;
  private infoTitle: string = '记录详情';
  private recordInfo: any = {}; // 记录详情
  private curRowData: any = {}; // 当前学生信息

  private options: any = {
    color: ['#7CB8F8', '#FF8A8A', '#FFD805'],
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        // 坐标轴指示器，坐标轴触发有效
        type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
      }
    },
    legend: {
      data: ['已记录', '未记录']
    },
    grid: {
      left: '3%',
      right: '4%',
      bottom: '3%',
      containLabel: true
    },
    xAxis: [
      {
        type: 'category',
        name: '班级',
        data: [],
        axisLabel: {
          interval: 0,
          rotate: 40
        }
      }
    ],
    yAxis: [
      {
        type: 'value',
        name: '单位：人'
      }
    ],
    series: [
      {
        name: '已记录',
        type: 'bar',
        stack: '记录',
        data: []
      },
      {
        name: '未记录',
        type: 'bar',
        stack: '记录',
        data: []
      }
    ]
  };
  private radarOptions: any = {
    tooltip: {},
    radar: {
      center: ['35%', '50%'],
      // shape: 'circle',
      name: {
        textStyle: {
          color: '#fff',
          backgroundColor: '#999',
          borderRadius: 3,
          padding: [3, 5]
        }
      },
      indicator: [
        { name: '语言', max: 24 },
        { name: '探索', max: 48 },
        { name: '社会性', max: 24 },
        { name: '精细动作', max: 24 },
        { name: '粗大动作', max: 45 }
      ]
    },
    series: [
      {
        type: 'radar',
        itemStyle: { // 单个拐点标志的样式设置。
          normal: {
            borderColor: 'rgba(70, 174, 132, 0.5)',
            // 拐点的描边颜色。[ default: '#000' ]
            borderWidth: 1
            // 拐点的描边宽度，默认不描边。[ default: 0 ]
          }
        },
        lineStyle: { // 单项线条样式。
          normal: {
            opacity: 0 // 图形透明度
          }
        },
        areaStyle: { normal: {
          color: 'rgba(70, 174, 132, 0.5)'
        } },
        data: [
          {
            value: [],
            name: ' '
          }
        ]
      }

    ]
  };
  private recordForm: any = {
    fromTime: Date.now(),
    toTime: Date.now(),
    classroomId: '',
    studentName: '',
    recordStatus: ''
  };

  /* 异常学生弹框 */
  private abnormityVisible: boolean = false;
  /* 未检查学生弹框 */
  private uncheckVisible: boolean = false;

  @Watch('staticTime', {
    immediate: true,
    deep: true
  })
  onChangeValue(newVal: string[], oldValue: string[]) {
    this.staticForm.fromTime = newVal.length ? newVal[0] : ''
    this.staticForm.toTime = newVal.length ? newVal[1] : ''
  }
  @Watch('recordTime', {
    immediate: true,
    deep: true
  })
  onrecordTimeChangeValue(newVal: string[], oldValue: string[]) {
    this.recordForm.fromTime = newVal.length ? newVal[0] : ''
    this.recordForm.toTime = newVal.length ? newVal[1] : ''
  }

  created() {
    this.getGrowthStatic()
    this.getClassList()
  }
  /**
   * 获取班级
   */
  private async getClassList() {
    const resp = await classroomList({
      page: 1,
      size: 9999
    })
    this.classList = (resp as any).data.array || []
  }
  /**
   * 查看弹框列表
   */
  private async viewRecord(row: any) {
    this.curRowData = row
    let Info = await growthInfo({ growthId: row.growthId })
    this.recordInfo = Info.data
    this.radarOptions.series[0].data[0].value = this.recordInfo.scoreValue
    this.radarOptions.radar.indicator.map((item:any, index:any) => {
      item.max = this.recordInfo.scoreMax[index]
    })
    this.infoVisible = true
    // console.log(this.$refs.radarChart as any)
    this.$nextTick(() => {
      (this.$refs.radarChart as any).setOption(this.radarOptions)
    })
  }
  /**
   * 导出详细数据
   */
  private async exportRecord() {
    let promise = null
    const resp = await growthRecordExport({
      ...this.recordForm
    })
    window.location = (resp as any).message
    return promise
  }

  /**
   * 详细数据查询
   */
  private search() {
    (this.$refs.table as any).search()
  }

  /**
   * 详细数据重置
   */
  private reset() {
    this.$nextTick(() => {
      (this.$refs.table as any).search()
    })
  }
  /**
   * 统计柱状图
   */
  private getGrowthStatic() {
    growthStatic({
      ...this.staticForm
    })
      .then(res => {
        let arr = res.data.array || []
        if (arr.length === 0) {
          this.options.xAxis[0].data = []
          this.options.series = [];
          (this.$refs.staticChart as any).setOption(this.options)
          return
        }

        let xAxis: any = []
        arr.map((item: any, index: any) => {
          xAxis.push(item.classroomName)
          this.options.series[0].data.push(item.growth.record)
          this.options.series[1].data.push(item.growth.notRecord)
        })
        this.options.xAxis[0].data = [...xAxis];
        (this.$refs.staticChart as any).setOption(this.options)
      })
      .catch(() => {})
  }
  /**
   * 统计
   */
  private staticSearch() {
    this.getGrowthStatic()
  }
  private staticReset() {
    this.staticForm.classroomIds = []
    this.getGrowthStatic()
  }
  /**
   * 记录
   */
  private recordSearch() {
    (this.$refs.table as any).search()
  }
  private recordReset() {
    Object.keys(this.recordForm).forEach(key => {
      this.recordForm[key] = ''
    })
    this.recordForm.fromTime = this.recordTime[0]
    this.recordForm.toTime = this.recordTime[1]
    this.$nextTick(() => {
      (this.$refs.table as any).search()
    })
  }
  /**
   * 记录时间筛选
   */
  private getTeachingRecored() {
    this.search()
  }
}
